import AppDialog from "../../../components/Common/AppDialog"
import RadioButtonGroupInGrid from "../../../components/Form/RadioButtonGroupInGrid";
import CustomTextField from "../../../components/Form/CustomTextField";
import CustomSelect from "../../../components/Form/CustomSelect";

const RequestMakeModelModal = ({ open, close, handleSubmit, windowWidth, formObj, setFormObj, makeList, error }) => {

    const handleClose = () => {
        close();
        setFormObj({});
    }

    const handleFormObjChange = (key, value) => {
        let updatedObj = { ...formObj };
        updatedObj[key] = value;
        setFormObj(updatedObj);
    }

    // const filteredModelList = makeList?.find((model) => model.name === formObj?.bike_make_name)?.models;

    return (
        <AppDialog
            title={'Request new make or model'}
            open={open}
            close={handleClose}
            positiveTitle={'Submit Request'}
            positivePress={() => handleSubmit()}
            negativeTitle={'Cancel'}
            negativePress={handleClose}
            negativeButtonStyle={{ border: "1px solid #F9F9F9", backgroundColor: '#F9F9F9', color: '#808588', width: "auto", borderRadius: 20 }}
            isMobile={windowWidth <= 768 ? true : false}
        >
            <div className="subheader-3 font-size-16">Can’t find the motorcycle make or model you’re looking for?</div>
            <div className="subheader-3 font-size-16">Submit a request and our admin team will review and add it if approved.</div>
            <div className="text-semibold my-3">What would you like to request?</div>
            <RadioButtonGroupInGrid
                data={[{ label: "New Motorcycle Make", value: 'motorcycle_make' }, { label: "New Motorcycle Model", value: 'motorcycle_model' }]}
                value={formObj?.request_type}
                setValue={(e) => handleFormObjChange('request_type', e)}
            />
            {
                formObj?.request_type === 'motorcycle_make' &&
                <>
                    <div className="my-2">
                        <CustomTextField
                            title={'Make name'}
                            placeholder={'Make name'}
                            values={formObj?.bike_make_name || ""}
                            onChange={(e) => handleFormObjChange('bike_make_name', e)}
                            error={error?.bike_make_name}
                        />
                    </div>
                </>
            }
            {
                formObj?.request_type === 'motorcycle_model' &&
                <>
                    <div className="mt-2">
                        <CustomSelect
                            title={'Make'}
                            placeholder={'Make'}
                            values={formObj?.bike_make_id || '-1'}
                            data={makeList || []}
                            labelName={'name'}
                            valueName={'id'}
                            onChange={(e) => handleFormObjChange('bike_make_id', e)}
                            error={error?.bike_make_id}
                        />
                    </div>
                    <div className="my-2">
                        <CustomTextField
                            title={'Model name'}
                            placeholder={'Model name'}
                            values={formObj?.bike_model_name || ""}
                            onChange={(e) => handleFormObjChange('bike_model_name', e)}
                            error={error?.bike_model_name}
                        />
                    </div>
                    <div className="mb-2">
                        <CustomTextField
                            title={'Model year'}
                            isOptional={true}
                            placeholder={'Model year'}
                            values={formObj?.bike_model_year || ""}
                            onChange={(e) => handleFormObjChange('bike_model_year', e)}
                            type={'number'}
                        />
                    </div>
                </>
            }

            <CustomTextField
                title={'Remarks'}
                isOptional={true}
                placeholder={'Remarks'}
                values={formObj?.remarks || ""}
                onChange={(e) => handleFormObjChange('remarks', e)}
                multiline={true}
                rows={4}
                error={error?.remarks}
            />
        </AppDialog>
    )
}

export default RequestMakeModelModal;